export default __webpack_public_path__ + "static/media/users-grey.0960bea8.svg";